/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import {FLOW_JAVASCRIPT_ENTRIES} from "./SourceDefType";

export default declareLinkedEntity({
    entity: "forms",
    graphQL: "Form",
    name: "Form",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultTitle: (data) => {
        return data['name'];
    },
    parentRelation: "forms",
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Form ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flowDef) => {
                return flowDef['id'];
            },
            parent: true,
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        onDefaultValue: {
            name: "On Default Value (JS)",
            type: "javascript",
            globalVariables: {
                ...FLOW_JAVASCRIPT_ENTRIES,
                "defaultValues": "defaultValues: Object",
                "formFields": "formFields[]",
                "htmlAddons": "htmlAddons",
            },
        },
        onSave: {
            name: "On Save (JS)",
            type: "javascript",
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            required: true,
        },
        noSubmit: {
            name: "No Submit Button",
            type: "boolean",
            defaultValue: false,
        },
        operation: {
            name: "Operation",
            type: "string",
            defaultValue: "",
            translatable: true,
            visibility: (data) => { return !data['noSubmit']; },
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        formFields: {
            type: 'oneToMany',
            to: types['formFields'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
    }; }
});
